import React, { useState, useEffect, useCallback } from 'react';
import Spinner from '@components/Spinner';
import UserService from '@services/userService';

export default function withMediaReview(WrappedComponent: any) {
  return () => {
    const [loading, setLoading] = useState(false);
    const [mediaFeedback, setMediaFeedback] = useState<User[]>();

    const fetchMediaFeedback = useCallback(() => {
      setLoading(true);
      UserService.getMediaReview().then((d) => {
        setMediaFeedback(d);
        setLoading(false);
      });
    }, []);

    useEffect(() => {
      if (!loading && !mediaFeedback) {
        fetchMediaFeedback();
      }
    }, [mediaFeedback, loading, fetchMediaFeedback]);

    if (loading) {
      return <Spinner />;
    }

    if (!mediaFeedback) {
      return null;
    }

    return <WrappedComponent mediaFeedback={mediaFeedback} onRefresh={fetchMediaFeedback} />;
  };
}
